/**
 * Utility functions for working with blobs and base64 data.
 * Mirrors {@code admin-portal}'s {@code BlobUtils} so both Angular projects decode
 * {@code FileTransfer.fileContent} the same way.
 */
export class BlobUtils
{
    /**
     * Converts a base64 string to a Blob.
     * @param base64String - the base64 encoded string
     * @param mimeType - the MIME type for the blob (default: 'application/octet-stream')
     * @returns a Blob object
     */
    static base64ToBlob(base64String: string, mimeType: string = 'application/octet-stream'): Blob
    {
        const cleanBase64 = base64String
            .replace(/^data:[^;]+;base64,?/i, '')
            .replace(/\s+/g, '');

        const byteCharacters = atob(cleanBase64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++)
        {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], {type: mimeType});
    }

    /**
     * Converts a base64 string to a PDF Blob.
     * @param base64String - the base64 encoded PDF string
     * @returns a PDF Blob object
     */
    static base64ToPdfBlob(base64String: string): Blob
    {
        return BlobUtils.base64ToBlob(base64String, 'application/pdf');
    }
}
